import { render, staticRenderFns } from "./UserPanel.vue?vue&type=template&id=7c496ed0&scoped=true&"
import script from "./UserPanel.vue?vue&type=script&lang=ts&"
export * from "./UserPanel.vue?vue&type=script&lang=ts&"
import style0 from "./UserPanel.vue?vue&type=style&index=0&id=7c496ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c496ed0",
  null
  
)

export default component.exports